export const STATUS_META = {
  overdue: { label: "Overdue", cls: "border-red-400/60 text-red-300 bg-red-500/10" },
  due_today: { label: "Due Today", cls: "border-[#D4AF37] text-[#D4AF37] bg-[#D4AF37]/10" },
  due_7: { label: "Due in 7 Days", cls: "border-blue-400/50 text-blue-300 bg-blue-500/10" },
  due_30: { label: "Due in 30 Days", cls: "border-sky-300/40 text-sky-200 bg-sky-500/5" },
  later: { label: "No Dues", cls: "border-white/20 text-white/50" },
  no_dues: { label: "No Dues", cls: "border-white/20 text-white/50" },
};
const sum = (xs) => xs.reduce((a, i) => a + i.outstanding, 0);
const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const fmtDay = (iso) => (iso ? `${Number(iso.slice(8, 10))} ${MON[Number(iso.slice(5, 7)) - 1]} ${iso.slice(0, 4)}` : "—");

export const daysText = (days) => {
  if (days === null || days === undefined) return "";
  if (days > 0) return `${days} day${days === 1 ? "" : "s"} overdue`;
  if (days === 0) return "Due today";
  return `due in ${-days} day${days === -1 ? "" : "s"}`;
};

// One combined row per player for the selected scope and category.
export const deriveRow = (row, scopeEnd, category) => {
  const items = row.items.filter((i) => i.outstanding > 0 && i.due <= scopeEnd && (category === "all" || i.category === category));
  if (!items.length) {
    if (category !== "all" || row.player.status !== "Active") return null;
    return { ...row, scoped: [], total: 0, dueNow: 0, upcoming: 0, overdueAmount: 0, status: "no_dues", due: row.next_due, days: row.next_days };
  }
  const lead = items.reduce((a, i) => (i.due < a.due ? i : a), items[0]);
  const now = items.filter((i) => i.status === "overdue" || i.status === "due_today");
  return { ...row, scoped: items, total: sum(items), dueNow: sum(now), upcoming: sum(items) - sum(now),
    overdueAmount: sum(items.filter((i) => i.status === "overdue")), status: lead.status, due: lead.due, days: lead.days };
};

export const matchesStatus = (r, s) => {
  if (s === "everyone") return true;
  if (s === "all") return r.status !== "no_dues";
  if (s === "due_7") return r.status === "due_7";
  if (s === "due_30") return r.status === "due_7" || r.status === "due_30";
  return r.status === s;
};

export const matchesSent = (n, s) => (s === "all" ? true : s === "0" ? n === 0 : s === "1-3" ? n >= 1 && n <= 3 : s === "4-7" ? n >= 4 && n <= 7 : n >= 8);

export const liveFlags = (row, category) => {
  const live = row.items.filter((i) => i.outstanding > 0 && (category === "all" || i.category === category));
  return { dueToday: live.some((i) => i.status === "due_today"), due7: live.some((i) => i.status === "due_7") };
};

export const monthEndOverdue = (row, monthEnd, category) => row.items
  .filter((i) => i.due <= monthEnd && (category === "all" || i.category === category))
  .reduce((a, i) => a + (i.outstanding_at_month_end || 0), 0);
